<div class="fixed flex h-full w-full items-center justify-center bg-black/50">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>
